module.exports = __webpack_public_path__ + "static/media/product1.e927e4cc.jpg";